// ---------------------------------------------------------------------
//  @ Role Permission Models
// ---------------------------------------------------------------------

import { Actions, SpecialActions } from 'app/core/security/actions';
import { Role } from 'app/core/security/interfaces';

// Module type - represents a system module
export type Module = string;

// Frontend model - what the component uses
export interface RoleModulePermission {
    id?: number;
    role: Role;
    module: Module;
    permissions: (Actions | SpecialActions)[];
    created_at?: string;
    updated_at?: string;
}

export interface RoleModulePermissionRequest {
    role: Role;
    module: Module;
    permissions: (Actions | SpecialActions)[];
}

export interface RoleModulePermissionResponse {
    success: boolean;
    message: string;
    data: RoleModulePermission | RoleModulePermission[];
}

// API Response model - what the backend returns
export interface ApiRoleModulePermission {
    id: number;
    rol_id: number;
    sho_module_id: number;
    permission_id: number;
    created_at: string;
    rol: {
        id: number;
        rol: string;
        deleteAt?: string | null;
    };
    sho_module: {
        id: number;
        module_name: string;
        description: string;
        is_active: boolean;
    };
    permission: {
        id: number;
        permission_type: string;
    };
}

// Mapper function: API response -> Frontend model
export function mapApiToFrontend(
    apiData: ApiRoleModulePermission
): RoleModulePermission {
    return {
        id: apiData.id,
        role: apiData.rol.rol as Role,
        module: apiData.sho_module.module_name,
        permissions: [apiData.permission.permission_type] as (
            | Actions
            | SpecialActions
        )[],
        created_at: apiData.created_at,
    };
}

// Legacy alias for backward compatibility
export type RolePermissionAssignment = RoleModulePermission;
export type RolePermissionRequest = RoleModulePermissionRequest;
export type RolePermissionResponse = RoleModulePermissionResponse;
